/**
 * Lighten or darken a hex color by a percentage.
 * To darken, pass a negative percent.
 * Example: lightenColor("#2a2c31", -20) will darken by 20%
 */
export function lightenColor(hex: string, percent: number) {
  const amt = Math.round(2.55 * percent);
  return (
    "#" +
    hex
      .replace(/^#/, "")
      .replace(/../g, (color) => ("0" + Math.min(255, Math.max(0, parseInt(color, 16) + amt)).toString(16)).slice(-2))
  );
}
